export class SpecialQuoteRequest{

  quoteNum!: string;
  cusno: number = 0;
  projectName!: string;
  numUnitsInProject!: number;
  numSpecialUnits!: number;
  equipmentMultiplier: number = 0;
  projectValue!: number;
  product: string[] = [];
  safetyAgencyApproval: string = "Y";
  description!: string;
  fileName!: string;
  file!: string;
  productManager!: string;
  regionalManager!: string;
  enteredBy!: string;
  competitorId: number = 1;
  processingStatus!: string;

}
